import Checkbox from 'components/Checkbox';
import {Close} from '@material-ui/icons';
import {
  DialogContent,
  Dialog as DialogMui,
  DialogTitle as DialogTitleMui,
  FormControlLabel,
  FormGroup,
  Paper as PaperMui,
  withStyles,
} from '@material-ui/core';
import {get, isEmpty} from 'lodash';
import {useEffect, useState} from 'react';
import {useLocalStorage} from 'hooks/useLocalStorage';
import {useSelector} from 'react-redux';

const Paper = withStyles(() => ({
  root: {
    width: '100%',
    '&.MuiDialog-paper': {
      marginRight: '2px',
      marginLeft: '2px',
      maxWidth: '1200px',
    },
  },
}))(PaperMui);

const Dialog = withStyles(() => ({
  root: {
    padding: 0,
    '.MuiDialogTitle-root': {
      padding: '24px 24px !important',
    },
  },
}))(DialogMui);

const DialogTitle = withStyles(() => ({
  root: {
    padding: '24px 24px',
  },
}))(DialogTitleMui);

const HIDE_POPUP_IN_MS = 500000;

const AnnouncementDialog = () => {
  const [storedValue, setStoredValue] = useLocalStorage('isReadAnnouncement', '');
  const level = useSelector(state => get(state, 'user.profile.level'));
  const announcement = useSelector(state => get(state, 'announcement.news.data.message'));
  const levelActive = useSelector(state => get(state, 'announcement.news.data.levelActive'));
  const announcementDate = useSelector(state => get(state, 'announcement.news.data.updatedAt'));

  const [openAnnouncement, setOpenAnnouncement] = useState(false);
  const [disabledAnnouncement, setDisabledAnnouncement] = useState(false);

  const handleClose = () => {
    setOpenAnnouncement(false);
  };

  const handleSubmit = () => {
    setOpenAnnouncement(false);
    if (disabledAnnouncement) {
      setStoredValue({disable: true, updatedAt: announcementDate});
    }
  };

  const getAnnouncementStorage = () => {
    if (!isEmpty(storedValue)) {
      const {disable, updatedAt} = storedValue;
      if (updatedAt !== announcementDate) {
        setStoredValue('');
        return {disable: false};
      } else if (disable) {
        setDisabledAnnouncement(true);
        return {disable: true};
      }
    }
    return {disable: false};
  };

  const checkLevel = () => {
    return levelActive === null || (levelActive && levelActive.includes(level)) || (levelActive && !levelActive.length);
  };

  const checkDisable = () => {
    const {disable} = getAnnouncementStorage();
    return disable;
  };

  useEffect(() => {
    if (!announcement) return;

    let announcementTimeOut;

    if (checkLevel() && !checkDisable()) {
      setOpenAnnouncement(true);

      announcementTimeOut = setTimeout(() => {
        setOpenAnnouncement(false);
      }, HIDE_POPUP_IN_MS);
    }

    return () => {
      announcementTimeOut && clearTimeout(announcementTimeOut);
    };
  }, [announcement]);

  return (
    <Dialog
      open={openAnnouncement}
      onClose={handleClose}
      aria-labelledby="alert-dialog-announcement"
      aria-describedby="alert-announcement"
      fullWidth
      scroll="paper"
      PaperComponent={Paper}>
      <DialogTitle>
        <div
          className="absolute right-1 top-1 cursor-pointer text-gray-500 bg-gray-500 rounded-md"
          onClick={handleClose}>
          <Close style={{color: 'white', fontSize: '42px'}} />
        </div>
      </DialogTitle>

      <DialogContent>
        <div className="bg-[#212121] flex flex-col items-center">
          <div dangerouslySetInnerHTML={{__html: announcement}} />
          <div className="flex mt-6 items-center">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={disabledAnnouncement}
                    onChange={() => setDisabledAnnouncement(!disabledAnnouncement)}
                  />
                }
                label="ไม่ต้องแสดงข้อความนี้อีก"
              />
            </FormGroup>
          </div>
          <div className="flex w-full justify-center">
            {/* <button
              className="bg-[#ff3547] min-w-[72px]  px-4 py-2 rounded-md mt-2 border-[4px] border-[#212121] hover:border-[#dc2e3c]"
              onClick={handleClose}>
              ปิด
            </button> */}
            <button
              className="w-full md:w-1/4 bg-[#655DCB] min-w-[72px] px-4 py-2 rounded-md mt-2 border-[4px] border-[#212121] hover:border-[#4e4a94]"
              onClick={handleSubmit}>
              ตกลง
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AnnouncementDialog;
